import styled from 'styled-components'
import { layout, space, typography } from 'styled-system'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const GenericLazyLoadImage = styled(LazyLoadImage)`
  ${layout}
  ${space}
  ${typography}
`

export default GenericLazyLoadImage
